module.exports = __webpack_public_path__ + "static/img/model_img.20a942e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/model_img.png
// module id = 186
// module chunks = 1